import {
  DashboardOutlined,
  SearchOutlined,
  CustomerServiceOutlined,
  BarChartOutlined,
  UserOutlined,
  CodeSandboxOutlined,
  UserSwitchOutlined,
} from "@ant-design/icons";

import { IMenuItem } from "../Interfaces/Config/SideMenuItems.interface";

const sideMenuItems: IMenuItem[] = [
  {
    key: "1",
    Icon: <DashboardOutlined />,
    title: "Home",
    url: "/home",
    privileges: ["0", "1", "2", "3", "20"],
  },
  {
    key: "2",
    Icon: <SearchOutlined />,
    title: "Search",
    url: "/search",
    privileges: ["3", "20"],
  },
  {
    key: "sub-1",
    Icon: <BarChartOutlined />,
    title: "Compliance Reports",
    subItems: [
      {
        key: "3",
        url: "/safety-document",
        title: "Safety Documents",
        privileges: ["3", "20"],
      },
      {
        key: "4",
        url: "/contact-compliance",
        title: "Contacts",
        privileges: ["3", "20"],
      },
      {
        key: "5",
        url: "/sites",
        title: "Sites",
        privileges: ["3", "20"],
      },
      {
        key: "6",
        url: "/cumulative-raw-data-report",
        title: "Cumulative Raw Data Report",
        privileges: ["3", "20"],
      },
      {
        key: "7",
        url: "/auditlog",
        title: "Audit Log",
        privileges: ["7"],
      },
    ],
  },
  {
    key: "sub-2",
    Icon: <UserSwitchOutlined />,
    title: "Libraries",
    privileges: ["9"],
    subItems: [
      {
        key: "8",
        url: "/user-management/sponsors",
        title: "Sponsors",
        privileges: ["9"],
      },
      {
        key: "9",
        url: "/user-management/roles",
        title: "User Roles",
        privileges: ["9"],
      },
      {
        key: "11",
        url: "/user-management/contact-library",
        title: "Contact Library",
        privileges: ["9"],
      },
      {
        key: "12",
        url: "/user-management/study-library",
        title: "Study Library",
        privileges: ["9"],
      },
      {
        key: "sub-3",
        title: "Product Library",
        privileges: ["9"],
        subItems: [
          {
            key: "14",
            url: "/user-management/active-ingredients",
            title: "Active Ingredients",
            privileges: ["9"],
          },
          {
            key: "15",
            url: "/user-management/products",
            title: "Products",
            privileges: ["9"],
          },
        ],
      },
    ],
  },
  {
    key: "16",
    Icon: <CodeSandboxOutlined />,
    title: "Reporting Rules",
    url: "/reporting-rules",
    privileges: ["10"],
  },
  {
    key: "17",
    Icon: <DashboardOutlined />,
    title: "Notifications",
    url: "/notifications",
    privileges: ["5", "6"],
  },
  {
    key: "18",
    Icon: <UserOutlined />,
    title: "Profile",
    url: "/profile",
  },
  {
    key: "19",
    Icon: <CustomerServiceOutlined />,
    title: "Support",
    url: "/support",
  },
];

export default sideMenuItems;
